import { useEffect, useState } from 'react';
import { Link, NavLink } from 'react-router-dom';
import { navLinks, site } from '@/mocks/site';

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 border-b transition-colors duration-300 ${
        scrolled
          ? 'border-background-200 bg-background-50/95 backdrop-blur'
          : 'border-transparent bg-background-50/70 backdrop-blur-sm'
      }`}
    >
      <div className="mx-auto flex h-16 w-full max-w-7xl items-center justify-between px-4 md:h-20 md:px-6">
        <Link to="/" className="flex items-center gap-2.5 cursor-pointer" aria-label={`${site.name} 首页`}>
          <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-primary-500 text-background-50 md:h-10 md:w-10">
            <i className="ri-plant-line text-lg md:text-xl"></i>
          </span>
          <span className="flex flex-col leading-none">
            <span className="font-heading text-lg font-bold tracking-wide text-foreground-950 md:text-xl">
              {site.name}
            </span>
            <span className="mt-0.5 hidden text-[11px] tracking-[0.18em] text-foreground-500 sm:block">
              GUATIAN ARCHIVE
            </span>
          </span>
        </Link>

        <nav className="hidden items-center gap-1 md:flex" aria-label="主导航">
          {navLinks.map((item) => (
            <NavLink
              key={item.to}
              to={item.to}
              end={item.to === '/'}
              className={({ isActive }) =>
                `cursor-pointer whitespace-nowrap rounded-full px-4 py-2 text-sm transition-colors ${
                  isActive
                    ? 'bg-primary-100 text-primary-800'
                    : 'text-foreground-700 hover:bg-background-100 hover:text-foreground-950'
                }`
              }
            >
              {item.label}
            </NavLink>
          ))}
        </nav>

        <div className="hidden md:flex">
          <Link
            to="/contact"
            className="inline-flex cursor-pointer items-center gap-2 whitespace-nowrap rounded-full bg-primary-500 px-5 py-2.5 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
          >
            <i className="ri-send-plane-line"></i>
            投稿爆料
          </Link>
        </div>

        <button
          type="button"
          onClick={() => setOpen((prev) => !prev)}
          className="flex h-10 w-10 cursor-pointer items-center justify-center rounded-lg border border-background-200 text-foreground-900 md:hidden"
          aria-label={open ? '收起菜单' : '展开菜单'}
          aria-expanded={open}
        >
          <i className={open ? 'ri-close-line text-xl' : 'ri-menu-line text-xl'}></i>
        </button>
      </div>

      {open ? (
        <div className="border-t border-background-200 bg-background-50 md:hidden">
          <div className="flex flex-col px-4 py-3">
            {navLinks.map((item) => (
              <NavLink
                key={item.to}
                to={item.to}
                end={item.to === '/'}
                onClick={() => setOpen(false)}
                className={({ isActive }) =>
                  `cursor-pointer whitespace-nowrap rounded-lg px-3 py-3 text-sm ${
                    isActive ? 'bg-primary-100 text-primary-800' : 'text-foreground-700'
                  }`
                }
              >
                {item.label}
              </NavLink>
            ))}
            <Link
              to="/contact"
              onClick={() => setOpen(false)}
              className="mt-2 inline-flex cursor-pointer items-center justify-center gap-2 whitespace-nowrap rounded-full bg-primary-500 px-5 py-2.5 text-sm font-medium text-background-50"
            >
              <i className="ri-send-plane-line"></i>
              投稿爆料
            </Link>
          </div>
        </div>
      ) : null}
    </header>
  );
}